import React from 'react';

function PaginationClassic({
  currentPage,
  totalItems,
  itemsPerPage,
  onPageChange
}) {
  // Add safety checks for undefined values
  const safeCurrentPage = currentPage || 1;
  const safeTotalItems = totalItems || 0;
  const safeItemsPerPage = itemsPerPage || 10;
  
  // Calculate total pages with null safety
  const totalPages = Math.ceil(safeTotalItems / safeItemsPerPage) || 1;
  
  // Generate page numbers (with null safety)
  const getPageNumbers = () => {
    // If there are fewer than totalPages, show all pages
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    
    // Otherwise show a subset with ellipsis
    if (safeCurrentPage <= 4) {
      return [1, 2, 3, 4, 5, '...', totalPages];
    } else if (safeCurrentPage >= totalPages - 3) {
      return [1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    } else {
      return [1, '...', safeCurrentPage - 1, safeCurrentPage, safeCurrentPage + 1, '...', totalPages];
    }
  };
  
  const pageNumbers = getPageNumbers();
  
  const handlePageClick = (page) => {
    if (page !== '...' && page !== safeCurrentPage) {
      onPageChange(page);
    }
  };
  
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
      <nav className="mb-4 sm:mb-0 sm:order-1" role="navigation" aria-label="Navigation">
        <div className="flex justify-center">
          <nav className="flex" role="navigation" aria-label="Navigation">
            <div className="mr-2">
              <button
                className={`btn-sm ${
                  safeCurrentPage <= 1
                    ? 'bg-indigo-500 text-white opacity-50 cursor-not-allowed'
                    : 'bg-indigo-500 hover:bg-indigo-600 text-white'
                }`}
                disabled={safeCurrentPage <= 1}
                onClick={() => handlePageClick(safeCurrentPage - 1)}
              >
                &lt;- Previous
              </button>
            </div>
            <ul className="inline-flex -space-x-px text-sm font-medium shadow-sm">
              {pageNumbers.map((page, index) => (
                <li key={index}>
                  <button
                    className={`inline-flex items-center justify-center px-3 py-1.5 ${
                      page === safeCurrentPage
                        ? 'bg-indigo-500 text-white'
                        : page === '...'
                        ? 'bg-white text-slate-300 cursor-default'
                        : 'bg-white text-indigo-500 hover:bg-indigo-50'
                    }`}
                    onClick={() => handlePageClick(page)}
                  >
                    {page}
                  </button>
                </li>
              ))}
            </ul>
            <div className="ml-2">
              <button
                className={`btn-sm ${
                  safeCurrentPage >= totalPages
                    ? 'bg-indigo-500 text-white opacity-50 cursor-not-allowed'
                    : 'bg-indigo-500 hover:bg-indigo-600 text-white'
                }`}
                disabled={safeCurrentPage >= totalPages}
                onClick={() => handlePageClick(safeCurrentPage + 1)}
              >
                Next -&gt;
              </button>
            </div>
          </nav>
        </div>
      </nav>
      <div className="text-sm text-slate-500 dark:text-slate-400 text-center sm:text-left">
        Showing <span className="font-medium text-slate-600 dark:text-slate-300">1</span> to <span className="font-medium text-slate-600 dark:text-slate-300">{ `${itemsPerPage > 9 ? '10' : itemsPerPage}` }</span> of <span className="font-medium text-slate-600 dark:text-slate-300">{totalItems}</span> results
      </div>
    </div>
  );
}

export default PaginationClassic;
